import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useState } from "react";
import { auth, provider } from '../firebase'; // Adjust the path if necessary
import { signInWithPopup } from "firebase/auth";
import { useHistory } from "react-router-dom";
import '../App.css';
import { useCart } from "../products/CartContext";

function Header() {

  const [openedDrawer, setOpenedDrawer] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const { cart } = useCart();
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  const handleLogin = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        setName(user.displayName);
        setIsLoggedIn(!isLoggedIn);
        setEmail(user.email);
        localStorage.setItem("email", user.email);
        localStorage.setItem(
          "user",
          JSON.stringify({
            fullName: user.displayName || "",
            email: user.email || "",
            phone: "",
            address: "",
            city: "",
            postalCode: ""
          })
        );
        console.log("User signed in: ", user);
      })
      .catch((error) => {
        console.error("Error during login: ", error);
      });
  };

  const handleLogout = () => {
    auth.signOut().then(() => {
      setIsLoggedIn(false);
      setName('');
      setEmail('');
      localStorage.setItem("email", "");
      localStorage.setItem("user", "");
      console.log("User signed out.");
    }).catch((error) => {
      console.error("Error during logout: ", error);
    });
  };

  function toggleDrawer() {
    setOpenedDrawer(!openedDrawer);
  }

  function changeNav(event) {
    if (openedDrawer) {
      setOpenedDrawer(false)
    }
  }
  const history = useHistory();

  return (
    <header>
      <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-white border-bottom">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/" onClick={changeNav}>
            <FontAwesomeIcon
              icon={["fas", "home"]}
              className="ms-1"
              size="lg"
            />
            <span className="ms-2 h5">Shop</span>
          </Link>
          <div className={"navbar-collapse offcanvas-collapse " + (openedDrawer ? 'open' : '')}>
            <ul className="navbar-nav me-auto mb-lg-0">
              <li className="nav-item">
                <Link to="/products" className="nav-link" replace onClick={changeNav}>
                  Sản Phẩm
                </Link>
              </li>
            </ul>
            <div className="me-3 d-none d-lg-inline">
              <span className="ms-3 badge rounded-pill bg-dark">An Phát - 0769.725.893</span>
            </div>
            <button type="button" className="btn btn-outline-dark me-3 d-none d-lg-inline"
              onClick={() => {
                changeNav();
                history.push("/checkout");
              }}>
              <FontAwesomeIcon icon={["fas", "shopping-cart"]} />
              <span className="ms-3 badge rounded-pill bg-dark">{cartCount}</span>
            </button>
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <button className="btn btn-primary"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={["fas", "user-alt"]} />
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                  {isLoggedIn ? (
                    <>
                      <li className="px-2 py-1">
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => alert("Xin chào " + name)}
                        >
                          {typeof name === "string" ? name : "User"}
                        </button>
                      </li>
                      <li className="px-2 py-1">
                        <button className="btn btn-sm btn-primary" onClick={handleLogout}>
                          Log Out
                        </button>
                      </li>
                      {email?.toLowerCase() === "tai.nguyennhu2204@gmail.com" && (
                        <li className="px-2 pt-2">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              changeNav();
                              history.push("/admin-product");
                            }}
                          >
                            Product Admin
                          </button>
                        </li>
                      )}
                    </>
                  ) : (
                    <li className="px-2 py-1">
                      <button className="btn btn-sm btn-primary" onClick={handleLogin}>
                        Login with Google
                      </button>
                    </li>
                  )}
                </ul>
              </li>
            </ul>

          </div>

          <div className="d-inline-block d-lg-none">
            <button type="button" className="btn btn-outline-dark">
              <FontAwesomeIcon icon={["fas", "shopping-cart"]} />
              <span className="ms-3 badge rounded-pill bg-dark">0</span>
            </button>
            <button className="navbar-toggler p-0 border-0 ms-3" type="button" onClick={toggleDrawer}>
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
